import exhibitorIcon from "../assets/exhibitor_icon.png";
export const ICON_TYPE_NON_IMAGE = "icon_type_non_image";
export const ICON_TYPE_IMAGE = "icon_type_image";
export const HEADER_RIGHT_NOTIFICATION = "header_right_notification";
export const HEADER_RIGHT_MESSAGE = "header_right_message";
export const HEADER_RIGHT_PROFILE = "header_right_profile";
export const MOBILE_THRESHOLD = 640;
export const VISITOR = "visitor";
export const TEAM = "team";
export const VISITORS = "visitors";
export const EXHIBITOR = "exhibitor";
export const IMTEX_EXHIBITOR = "imtexExhibitor";
export const EXHIBITOR_TOKEN = "exhibitor_token";
export const PROFILE_IMAGE = "profile_image";
export const PROFILE_BANNER = "profile_banner";
export const MEETINGS = "meetings";
export const USER = "user";
export const ADMIN = "admin";
export const LONG_DASH = "—";
export const APP_LOGO = "/app_logo.png";
export const HEADER_RIGHT_MODE_SETTINGS = "header_right_mode_settings";
export const TRANSPARENCY = 0.8;
export const DRAWER_WIDTH = 240;
export const MAIN_DOMAIN = "expoplanner.in";
export const EVENT_NAME = "";
export const LOCAL = "local";
export const PRODUCTION = "production";
export const APP_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6InRlc3RhcHAiLCJuYW1lIjoiRXhwb1BsYW5uZXIgRGVtbyIsImlhdCI6MTc0OTcxNDUxNywiZXhwIjoxNzgxMjcyMTE3fQ.cNmuBgC6CfSPJ2iVQcjnDRanhk0Mt5X9IsgomVhdwMo";
export const state = PRODUCTION;
export const API_ENDPOINT =
  state === PRODUCTION
    ? "https://apis.expoplanner.in/"
    : "http://localhost:5002/";
export const VISITOR_API = `${API_ENDPOINT}visitor/`;
export const EXHIBITOR_API = `${API_ENDPOINT}exhibitor/`;
export const INTERACTION_API = `${API_ENDPOINT}interactions/`;
export const EVENT_API = `${API_ENDPOINT}event/`;
export const ADMIN_API = `${API_ENDPOINT}admin`;
export const DEFAULT_DP = `https://s3.ap-south-1.amazonaws.com/expoplanner.in/uploads/expo_expo_placeholder.png`;
export const EXHIBITOR_PLACEHOLDER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/DALL%C2%B7E+2024-03-25+10.05.56+-+Design+a+simplistic+logo+for+an+exhibitor+company%2C+featuring+a+stylized+version+of+a+company+building.+The+logo+should+be+minimalistic%2C+utilizing+clea.webp";
export const EXHIBITOR_PLACEHOLDER2 =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/exhibitor_placeholder.png";
export const DEFAULT_EX_ICON = exhibitorIcon;
export const INTERACT_MEETING = "interact_meeting";
export const INTERACT_MESSAGE = "interact_message";
export const INTERACT_FAVORITE = "interact_favorite";
export const LOGIN_BANNER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/Login+Banner.webp";

export const APP_HEADER_LOGO =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX+25+_+Organiser.webp";

export const EMAIL_HEADER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX+25+_+Banner_Visitor+registration.png";
export const EMAIL_FOOTER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX+25+_Footer.webp";
export const VISITOR_REG_HEADER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/Header+1200x150.png";
export const CONFIRMATION_HEADER =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX+25+_+Password+Banner.webp";
export const BADGE_BG =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX2025BadgeBG.png";
export const LOGIN_HEADER_BG =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/IMTEX+25+_+Password+Banner.webp";
export const OES_MANUAL =
  "https://s3.ap-south-1.amazonaws.com/expoplanner.in/PMTX+2024+-+Exhibitor+Manual+(15+April+2024).pdf";
export const MODULES = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
    ["link", "image"], // this line adds the image and video options
  ],
};
export const OES_COMPONENTS = [];

export const SUPPLIER_LIST = [];
export const PRODUCT_CATEGORIES = [];
export const PUNE_CATEGORIES = [];
